import React, { Component } from "react";

export class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: ""
    };
  }

  handleChange = event => {
    this.setState({ searchInput: event.target.value }, () =>
      this.globalSearch()
    );
  };

  globalSearch = () => {
    let { searchInput } = this.state;
    let { fields, data } = this.props;
    //console.log(searchInput, fields, data);
    let filteredData = [];
    fields.map(field => {
      let fieldData = data.filter(
        value =>
          value[field] &&
          value[field].toLowerCase().includes(searchInput.toLowerCase())
      );
      filteredData = [...filteredData, ...fieldData];
      return field;
    });
    let uniq = {};
    filteredData = filteredData.filter(
      obj => !uniq[obj.id] && (uniq[obj.id] = true)
    );

    this.props.handleSetData(filteredData, searchInput);
  };

  render() {
    return (
      <input
        size="large"
        name="searchInput"
        value={this.state.searchInput || ""}
        onChange={this.handleChange}
        label="Search"
        placeholder="Search"
      />
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/common/Search/index.js